module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "CHAPTER1",
    attrs: {
      "id": "uai2OkJuwycfyvbQGdRVAK6",
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "id": "u6rzEwqobLVsoDJ2asutLG9"
    }
  }), _vm._v("1. THE GABARDINE GANG")])]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("This is a short story about how the “Gabardine Gang” hailing from Hartford, Connecticut, and headed by Geno, my father, got its name.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The “Gabardine Gang” was a group of guys, mostly Italian, who, in the decades spanning the fifties and sixties, ran an organized crime organization which controlled the dark side of Hartford, Connecticut.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("There are about a hundred or so miles between Hartford and New York and another seventy miles between Hartford and New Jersey. Closer to home Providence and Boston crime syndicates made those bigger cities seem far away. Hartford is at the hub of two major interstates that connect all these places, we lived close enough to Boston and New York to know what their bigger organized crime operations were doing and what was making money for them. My dad also kept tabs on the new money-making concepts these larger gangs were involved in.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The Gabardine Gang was a group of small-time gangsters who were nothing like the Mafia guys you’ve probably heard about. For starters, they were not the glamorous, expensive suit wearing types. In fact, the nickname “Gabardine Gang” stemmed from a joke my mom made the day after a score (stolen goods) delivery I secretly witnessed when I was only about five years old.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("A knock on our apartment door woke me up.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I got out of bed in time to peek out of my bedroom door and see a couple of my dad’s crew come in carrying about half a dozen brand new Gabardine suits, all assorted colors, still in plastic bags, the tags intact. My parents gathered in the living room as the suits were laid out on the couch. My dad was immediately drawn to a light gray one. Once he tried it on, you could see the two of them became instant friends, although my mom was indifferent to this new infatuation.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Even though he could have easily afforded this suit on his own, my dad kept it, the guys took the rest and left. I was able to close my door before my spying was detected. The next day, my dad brought his new best friend to a local tailor he used on a regular basis and had it custom fit. Dad always wanted things exactly the way he wanted.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("A couple of days later, a guy in a new Cadillac pulled up to Pal’s, the luncheonette my dad owned and delivered the suit to him. Geno, happy and proud, crossed Barbour Street to our apartment, placed the suit in the closet and went back to Pal’s.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("My dad was head over heels in love with my mother at that time, and he loved teasing her. I have always believed this was one of the reasons she loved him. Not only could she tolerate his teasing and overall bad behavior, but she could give it as well as she could take it. like, “So the night Dad got his suit back from the tailor, he jokingly told my mom “Some of the girls were stopping by to see the new haul,” meaning the two prostitutes who lived underneath us on the second floor, were coming by to see his new suit.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("My mom proceeded to bust his chops with a line I’ll never forget.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You bring any of those sluts around here and you will find yourself and your Gabardine Gang out on the street!”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("My mother was the only person who could get away with a joke like that and they both laughed at it. “The Gabardine Gang” became a private joke in our family and it stuck in my head. I kept that suit until I was nearly sixty to remind me of those times.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The core members of The Gabardine Gang were my father, Geno; Sonny, my dad’s Black bodyguard; Henry, my father’s money man and accountant; Johnny “Knucks,” a former light heavy weight boxer who often helped Sonny with some of the more physical tasks; John, a Hartford detective on my dad’s payroll who helped keep everyone out of trouble; David and Moshe, middle men who moved high-end stolen merchandise; Sam, the butcher who ran the local deli; the Rizzo brothers, two local Italian thugs and about a dozen other characters including Nick “The Fatman,” Bob “Meat” (another butcher), David “The Eggplant,” Tommy “Pork Chops,” Henry “The Carp” and Tony “Ugatz” all of them looked up to my father as a leader.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("My dad and his crew of misfits ran their small, but profitable, operation out of Pal’s, his luncheonette on Barbour Street in Hartford’s North End of Hartford.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The Gabardine operation made money from gambling operations, looting, fencing high-end items, prostitution, and bribery. They also had interests in loan sharking, protection money and a couple other business ventures.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Clearly, they weren’t fancy dressers, nor did they live in mansions or have maids and other staff. They were blue collar” mobsters, or as I call them, “low-level gangsters.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Even today, gangsters like this exist in the seedy underbelly of every major city but you will almost never know their names or hear about them on the news. These anonymous people are the backbone of organized crime, and their gangs work your local streets, making a living doing whatever they have to. There are far more of these low-level gangs than there are those with family heads, or godfathers as they’re sometimes called in the media and pop culture.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "ubvxILUKVXpoy32OcFw9QKH"
    }
  }), _vm._v("Pal’s had a long shiny chrome lunch counter and a greasy spoon menu. The rest of the room was filled with wall-to-wall slot machines and two-way mirrors behind which my dad and his cohorts would assess and plan their business moves in a small, smoke-filled office. Most of the time, I wasn’t allowed to be around there when the grown-ups were meeting; I was too young. But I was irrepressible and relentlessly inquisitive about everything and managed to get a first-hand look at what went on in this little luncheonette, some of my dad’s other business concerns and in our neighborhood."), _c('a', {
    attrs: {
      "id": "ufoBneUYf89lJE9x24YTuV7"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21feb670","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Chap_01.vue
// module id = 72
// module chunks = 0